import { TextWithImageItem, TextWithImageItemProps, IMAGE_POSITION } from './TextWithImageItem'

export default TextWithImageItem

export { type TextWithImageItemProps, TextWithImageItem, IMAGE_POSITION }
